import { CircularProgress, Typography } from "@material-ui/core";

import {
  CheckOutlined,
  ChevronRight,
} from "@material-ui/icons";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import React from "react";

import { ProfileIcon } from "../../assets";
import { KitchenOrder } from "../../types";

import useStyles from "./styles";
import { KitchenOrderActions } from "../KitchenOrderActions";
import { useEntity } from "../../hooks/useEntity";

export interface OrderSchedule extends KitchenOrder {
  name: string;
  enrollment: string;
  orderAction: (id: string) => void;
  cancelOrder: (id: string) => void;
  selectOrder: () => void;
  onPrint: (id: string) => void;
  handleProfileClick: () => void;
  isLoading?: boolean;
  hasPrinter?: boolean;
}

export const CardOrderSchedule: React.FC<OrderSchedule> = ({
  id,
  scheduleFor,
  client,
  items,
  name,
  enrollment,
  isLoading,
  hasPrinter,
  isPending,
  descriptionPeriod,
  orderAction,
  cancelOrder,
  selectOrder,
  handleProfileClick,
  onPrint,
}) => {
  const verifyEnrollment = () => {
    if (!enrollment) return null;

    return (
      <Typography component="span" className={Styles.ownerEnrollment} noWrap>
        {enrollment}
      </Typography>
    );
  };

  const { showObservations } = useEntity();
  const Styles = useStyles({ client });

  return (
    <div className={Styles.card}>
      <div className={Styles.orderInfos}>
        <div className={Styles.orderTop}>
          <div className={Styles.orderOwner}>
            <div className={Styles.ownerPhoto}>
              {client?.picture ? (
                <div className={Styles.picture} onClick={handleProfileClick} />
              ) : (
                <ProfileIcon className={Styles.profileIcon} />
              )}
            </div>
            <div className={Styles.collunName}>
              <Typography component="span" className={Styles.ownerName} noWrap>
                {name}
              </Typography>
              {verifyEnrollment()}
            </div>
          </div>

          {scheduleFor && (
            <div className={Styles.orderTime}>
              <Typography component="span">
                {format(new Date(scheduleFor), "dd/MM/yyyy", { locale: ptBR })}
              </Typography>
              <Typography component="span">
                {format(new Date(scheduleFor), "HH:mm", { locale: ptBR })}
              </Typography>
              {descriptionPeriod && (
              <Typography component="span">{descriptionPeriod}</Typography>
              )}
            </div>
          )}
        </div>

        <div>
          <div className={Styles.products}>
            {items
              .filter((_item) => _item.quantity > 0)
              .map((item) => (
                <div key={item.id} className={Styles.product}>
                  <div className={Styles.amount}>
                    <Typography component="span">{item.quantity}</Typography>
                  </div>
                  {showObservations && item.observation ? (
                    <div className={Styles.details}>
                      <div className={Styles.name}>
                        <Typography component="span">
                          {item.name}
                        </Typography>
                      </div>
                      <div className={Styles.observation}>
                        <Typography component="span">
                          Observação:
                          {' '}
                          {item.observation}
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    <div className={Styles.name}>
                      <Typography component="span">
                        {item.name}
                      </Typography>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
        <KitchenOrderActions
          onPrint={hasPrinter && onPrint ? () => onPrint(id) : undefined}
          onEdit={selectOrder}
          onCancel={() => cancelOrder(id)}
        />
      </div>

      <div className={Styles.orderAction} onClick={() => orderAction(id)}>
        {isPending ? (
          <>{!isLoading ? <ChevronRight /> : <CircularProgress />}</>
        ) : (
          <>{!isLoading ? <CheckOutlined /> : <CircularProgress />}</>
        )}
      </div>
    </div>
  );
};
